import { cn } from '../../../../lib/utils/cn';
import { archiveStatusOf } from '../../constants/archive-status';

export interface ArchiveBadgeProps {
  isArchived: boolean;
}

/** Same chip as the Learning Suite `ReleaseBadge`, for the archive state. */
const ArchiveBadge = ({ isArchived }: ArchiveBadgeProps) => {
  const status = archiveStatusOf(isArchived);

  return (
    <span className={cn('text-[11px] font-semibold px-2 py-1 rounded-full inline-flex items-center gap-1.5 shrink-0', status.chip)}>
      <span className={cn('w-[7px] h-[7px] rounded-full shrink-0', status.lamp)} />
      {status.label}
    </span>
  );
};

export default ArchiveBadge;
